import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FrameContainer from 'components/consumer/FrameContainer';
import OrderLookupForm from './components/OrderLookupForm';
import OrderIssueForm from './components/OrderIssueForm';
import OrderIssueSuccess from './components/OrderIssueSuccess';
const WarrantyFormS3 = t0 => {
  const $ = _c(18);
  const {
    isAdmin
  } = t0;
  const [step, updateStep] = useState("order_lookup_form");
  const [orderLookInfo, updateOrderLookupInfo] = useState(null);
  const [orderInfo, updateOrderInfo] = useState(null);
  let t1;
  let t2;
  if ($[0] !== orderInfo || $[1] !== orderLookInfo || $[2] !== step) {
    t1 = () => {
      if (step === "order_lookup_form" && orderInfo) {
        updateStep("order_issue_form");
      } else {
        if (step === "order_issue_form" && !orderInfo && !orderLookInfo) {
          updateStep("order_lookup_form");
        }
      }
    };
    t2 = [orderInfo, orderLookInfo, step];
    $[0] = orderInfo;
    $[1] = orderLookInfo;
    $[2] = step;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (isAdmin) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div>WarrantyForm Placeholder for Variant Builder. <br />The component will display correctly in Consumer</div>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== step) {
    t3 = step === "order_lookup_form" && <OrderLookupForm actions={{
      updateOrderInfo,
      updateOrderLookupInfo
    }} />;
    $[6] = step;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== orderInfo || $[9] !== orderLookInfo || $[10] !== step) {
    t4 = step === "order_issue_form" && <OrderIssueForm actions={{
      updateStep,
      updateOrderInfo,
      updateOrderLookupInfo
    }} state={{
      step,
      orderLookInfo,
      orderInfo
    }} />;
    $[8] = orderInfo;
    $[9] = orderLookInfo;
    $[10] = step;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== step) {
    t5 = step === "order_issue_success" && <OrderIssueSuccess />;
    $[12] = step;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <FrameContainer><div><div>{t3}{t4}{t5}</div></div></FrameContainer>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
WarrantyFormS3.propTypes = {
  isAdmin: PropTypes.bool
};
export default WarrantyFormS3;